import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, Container } from 'reactstrap'
import CommonService from 'services/CommonService';
import { useNavigate } from 'react-router-dom';
import { forkJoin } from 'rxjs';
import { IColumnModel } from 'models/IColumnModel';
import CustomDataTable from 'components/shared/CustomDataTable';
import { TablePagePerView } from 'components/constants/dsmConstants';
import { RoleModel } from 'models/IRole.Model';
import { ISearchModel } from 'models/ISearch.Model';
import { checkIsAccess } from '../../helpers/Helper';
import CustomLoader from 'components/Common/CustomLoader';

function UserRoleScreen() {
    const [role, setRole] = useState<any>([]);
    const [selectedColumn, setSelectedColumn] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const [search, setSearch] = useState("");
    const [showLoading, setShowLoading] = useState(true);
    let navigate = useNavigate();

    const [rowsPerPage] = useState<number>(50);
    const [currentPage, setCurrentPage] = useState<any>(1);
    const [offsetStart, setOffsetStart] = useState<number>(0);

    const columns: IColumnModel[] = useMemo(() => [
        {
            Header: 'Id',
            accessor: 'Id',
            Filter: true,
            sortable: true,
            displayInList: false,
            width: '0%'
        }, {
            Header: 'Roles',
            accessor: 'Name',
            Filter: true,
            sortable: true,
            width: '30%'
        },
    ], []);

    const GetOrderSummary = () => {
        setShowLoading(true)
        CommonService.postWithOutData('userRoleScreenActivity', 'GetUserRoleList').then(res => {
            if (res.status == 200) {
                setShowLoading(false)
                let data: Array<RoleModel> = res.data
                setRole(data);
            }
        });
    }

    const searchByText = (pageNumber: any, searchText: any, sortcolumn?: string, sortorder?: string) => {

        let searchModel: ISearchModel = {
            offsetStart: pageNumber,
            rowsPerPage: TablePagePerView.Count,
            sortOrder: sortorder ? sortorder : "",
            sortOrderColumn: sortcolumn ? sortcolumn : "",
            searchText: searchText
        }

        CommonService.post("userRoleScreenActivity", "GetUserRoleList", searchModel).then(res => {
            if (res.status == 200) {
                let data: Array<RoleModel> = res.data
                setRole(data);
            }
        });
    }

    const createHandler = () => {
    }

    const editHandler = (val: any) => {
        setShowLoading(true)
        window.location.href = `/screen-accessibility/${val.Id}`;
        setShowLoading(false)
    }

    const deleteHandler = (val) => {
        // setDelect(val.id);
        // setConfirmModel(true);
    }

    const pagination = (pageNumber: any) => {
        let getPageNumber = ((pageNumber - 1) * 10);
        searchByText(getPageNumber, search, selectedColumn, sortOrder);
    }

    const searchHandler = (searchKeyword: any) => {
        setSearch(searchKeyword);
        searchByText(0, searchKeyword);
    }

    const onColumnSortChange = (columnName, sortorder) => {
        setSelectedColumn(columnName);
        setSortOrder(sortorder);
        searchByText(0, search, columnName, sortorder);
    };

    useEffect(() => {
        // searchByText(0, "");
        GetOrderSummary();
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <CustomLoader isOpen={showLoading} />
                    <div>
                        <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>SCREEN ACCESSIBILITY</h5>
                    </div>
                    <Card>
                        <CardBody>
                            <CustomDataTable
                                data={role}
                                customPageSize={role?.length}
                                columns={columns}
                                isPagination={false}
                                isGlobalFilter={false}
                                selectedPage={pagination}
                                perPageData={TablePagePerView.Count}
                                searchHandler={searchHandler}
                                isActionEdit={false}
                                isActionDelete={checkIsAccess("5", "Screen_Activity")}
                                canShowButton1={checkIsAccess("2", "Screen_Activity")}
                                canEdit={true}
                                editHandler={editHandler}
                                deleteHandler={deleteHandler}
                                path=''
                                onColumnSortChange={onColumnSortChange}
                                canShowButton2={false}
                                createHandler={undefined}
                                firstBtnName={''}
                                pageSize={rowsPerPage}
                                rowsPerPage={rowsPerPage}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                offsetStart={offsetStart}
                                setOffsetStart={setOffsetStart}
                            />
                        </CardBody>
                    </Card>

                </Container>
            </div>
        </React.Fragment>
    )
}

export default UserRoleScreen
